var _circle, _circle2, _circle3, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCategorySalon = function SvgCategorySalon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 56 56"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 39.667,
    cy: 16.333,
    r: 9.333,
    fill: "#fdcbca"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 21,
    cy: 35,
    r: 14,
    fill: "#fdcbca"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 18.667,
    cy: 11.667,
    r: 2.333,
    fill: "#fdcbca"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "#ac293c"
  }, /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.3,
    d: "M43.027 22.109v1.755a2.005 2.005 0 0 1-2.005 2.005H39.14v7.953l1.977 4.944c.844 2.108-.709 4.4-2.98 4.4s-3.822-2.292-2.979-4.4l1.977-4.94v-7.957h-1.88a2.005 2.005 0 0 1-2.006-2.005v-7.02a4.01 4.01 0 0 1 4.01-4.01h1.757a4.01 4.01 0 0 1 4.01 4.01v1.755m-4.888 18.117-1.118 2.795a1.204 1.204 0 1 0 2.236 0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ac293c",
    d: "M43.15 20.522a.15.15 0 1 1-.3 0 .15.15 0 0 1 .3 0z"
  }), /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.3,
    d: "M18.005 41.502c.973.424 2.053.661 3.204.661h2.552c5.422 0 9.281-5.267 7.648-10.437l-.195-.615-.759-3.696a6.015 6.015 0 0 0-5.801-4.805h.275a1.63 1.63 0 0 0 0-3.259H20.04a1.63 1.63 0 1 0 0 3.259h.277a6.015 6.015 0 0 0-5.802 4.805l-.76 3.696-.194.615c-.786 2.49-.3 5 1.022 6.936"
  }), /*#__PURE__*/React.createElement("path", {
    strokeWidth: 1.3,
    d: "M25.908 34.75a3.424 3.424 0 1 1-6.847 0 3.424 3.424 0 0 1 6.847 0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ac293c",
    d: "M16.317 40.317a.15.15 0 1 1-.3 0 .15.15 0 0 1 .3 0z"
  }))));
};
export default SvgCategorySalon;